// import { useParams, useNavigate,Link,useLocation } from 'react-router-dom';
// import { useState, useEffect, useRef } from 'react';
// import axios from 'axios';
// import ClientView from './ClientView';
// import DocumentDetails from '../DocumentDetails';
// import ProjectList from '../project/ProjectList';
// import SelectedContact from '../contact/SelectedContact';
// import { useAuth } from '../../context/AuthContext';
// import withPermission from '../../utils/withPermission';
// import { Container, Card, Tabs, Tab, Button } from 'react-bootstrap';
// import { BiPencil } from "react-icons/bi";
// import { BsChevronLeft } from "react-icons/bs";
// import ClientModal from './ClientModal';
// const ClientDetails = () => {
//     const { id } = useParams(); // Get instance ID from the URL

//     const navigate = useNavigate();
//     const location = useLocation();
//     const [isSales, setIsSales] = useState(false);

//     const [clientDetails, setClientDetails] = useState(null);
//     const [activeTab, setActiveTab] = useState('projectList');
//     const WithtProjectPermission = withPermission(({ children }) => children, ['project-list']);
//     const WithContactPermission = withPermission(({ children }) => children, ['contact-list']);
//     const WithDocPermission = withPermission(({ children }) => children, ['document-list']);
//     const [showModal, setShowModal] = useState(false);
//     const [selectedClient, setSelectedClient] = useState(null);
//     const queryParams = new URLSearchParams(location.search);
//     const initialTab = queryParams.get("activeTab") ||"projectList"
//     const didFetchRef = useRef(false); 
//     const [countries, setCountries] = useState([]);
//     const [contacts, setContacts] = useState([]);

//     const fetchClientDetails = async () => {
//         try {
//             const backendUrl = process.env.REACT_APP_BACKEND_URL;

//             const userInfo = JSON.parse(localStorage.getItem('user-info'));
//             const origin = localStorage.getItem('user-origin');

//             const token = userInfo?.token;

//             const response = await axios.get(`${backendUrl}/api/contacts/${id}?type=client`, {
//                 headers: {
//                     'Authorization': `Bearer ${token}`,
//                     'Tenant-Origin': origin,

//                 },
//             });
//             console.log(response.data); // Check the data structure
//             const data = response.data.Data;

//             setClientDetails(data); // Set the fetched data to state
//             setIsSales(!!data.issales);            
//             console.log('sele:',isSales);
//         } catch (error) {
//             console.error('Error fetching instance details:', error);
//         }
//     };
//     const fetchCountries = async () => {
//         try {
//             const backendUrl = process.env.REACT_APP_BACKEND_URL;
//             const userInfo = JSON.parse(localStorage.getItem('user-info'));
//             const origin = localStorage.getItem('user-origin');

//             const token = userInfo?.token;

//             const response = await axios.get(`${backendUrl}/api/countries`, {
//                 headers: { Authorization: `Bearer ${token}` ,
//                 'Tenant-Origin': origin,

//             },
//                 skipLoader: true,

//             });
//             setCountries(response.data.Data);
//         } catch (error) {
//             console.error('Error fetching countries:', error);
//         }
//     };
//     const editContact = async (contactId, updatedData) => {
//         try {
//             const formData = new FormData();

//             Object.keys(updatedData).forEach((key) => {
//                 if (key === "avatar" && typeof updatedData[key] === "string") {
//                     // Only add avatar as a file if it's a new upload
//                     return;
//                 }
//                 formData.append(key, updatedData[key]);
//             });

//             if (updatedData.avatar instanceof File) {
//                 formData.append('avatar', updatedData.avatar); // Only append if it's a valid image file upload
//             }


//             const backendUrl = process.env.REACT_APP_BACKEND_URL;
//             const userInfo = JSON.parse(localStorage.getItem('user-info'));
//             const origin = localStorage.getItem('user-origin');

//             const token = userInfo?.token;

//             const response = await axios.post(`${backendUrl}/api/contacts/${contactId}?_method=PUT&type=client`, formData, {
//                 headers: {
//                     Authorization: `Bearer ${token}`,
//                     'Content-Type': 'multipart/form-data',
//                     'Tenant-Origin': origin,

//                 },
//             });
//             const updatedContact = response.data.Data;

//             if (updatedContact) {

//                 setClientDetails((prevContacts) => ({
//                     ...prevContacts,
//                     ...updatedContact, // Merge updated data
//                 }));
//                 setContacts((prevContacts) =>
//                     prevContacts.map((contact) => (contact.id === updatedContact.id ? updatedContact : contact))
//                 );
//             } else {
//                 console.error('Update failed, no data returned.');
//             }

//             setShowModal(false);
//         } catch (error) {
//             if (error.response?.data?.errors) {
//                 return error.response.data.errors; // Return validation errors
//             } else
//                 console.error(`Error updating client`, error);
//         }
//     };



//     useEffect(() => {
//         if (!didFetchRef.current) {
//             fetchClientDetails(); // Only fetch data if it hasn't been done before
//             didFetchRef.current = true; // Mark that data has been fetched
//         }
//     }, [id]); // This will run only when `id` changes

//     // Handle back button click
//     const handleBackClick = () => {
//         navigate(-1);
//     };
//     useEffect(() => {
//         if (clientDetails) { 
//             const queryParams = new URLSearchParams(location.search);
//             let activeTabParam = queryParams.get("activeTab");

//             if (clientDetails.issales) {
//                 queryParams.set("sales", "true"); // Ensure sales=true is set

//                 if (!activeTabParam) {
//                     queryParams.set("activeTab", "projectList"); // Default to projectList only if no tab is set
//                 }

//                 navigate(`${location.pathname}?${queryParams.toString()}`, { replace: true });
//             } else {
//                 if (!activeTabParam) {
//                     setActiveTab("projectList"); // Default to "details" if no tab is present
//                 } else {
//                     setActiveTab(activeTabParam);
//                 }
//             }
//         }
//     }, [clientDetails]); // Only run when clientDetails change



//       const [refreshKey, setRefreshKey] = useState(0);

// const handleAvatarUpdate = (newAvatarUrl) => {
//     console.log("New Avatar URL:", newAvatarUrl);

//     setClientDetails((prevDetails) => ({
//         ...prevDetails,
//         avatar: newAvatarUrl,
//     }));

//     setRefreshKey(prev => prev + 1); // Force re-render
// };
// const handleTabClick = (tab) => {
//     const queryParams = new URLSearchParams(location.search);
//     queryParams.set("activeTab", tab);

//     if (isSales) {
//         queryParams.set("sales", "true");
//     } else {
//         queryParams.delete("sales");
//     }
//     setActiveTab(tab);
//     navigate(`${location.pathname}?${queryParams.toString()}`);
// };

//     return (
//         <div className="main-content">
//             <div className="page-content">
//                 <div className="container-fluid">
//                     {/* Page Title */}
//                     <div className="row">
//                         <div className="col-12">
//                             <div className="page-title-box d-sm-flex align-items-center justify-content-between">
//                             <h4 className="mb-sm-0 d-flex align-items-center">
//                                     <BsChevronLeft
//                                         className='back-button1'
//                                         onClick={() => navigate(-1)}
//                                     />
//                                     <span>Client</span>
//                                 </h4>                                
//                                 <div className="page-title-right br-font">
//                                     <ol className="breadcrumb m-0">
//                                         <li className="breadcrumb-item"><Link to={`/contacts/client/details/${id}?activeTab=clientInfo`}>
//                                             {clientDetails?.name || " Client Details"}
//                                         </Link></li>
//                                         <li className="breadcrumb-item active">Details</li>
//                                     </ol>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                     <div className="p-6 max-w-7xl mx-auto">
//                     <>
//                     <div className="row  align-items-stretch">
//     {/* Main Info Card */}
//     <div className="col-md-10">
//         <Card className="mb-2 shadow-sm rounded-3 p-2 border-0 card-bg">
//             {/* Header Section with Name and Edit Icon */}
//             <div className="d-flex justify-content-between align-items-center">
//                 <Card.Title className="fw-bold font-size-14 text-primary">{clientDetails?.name}</Card.Title>
//                 <BiPencil
//                     className="text-primary hover-effect2 edit-pencil"
//                     onClick={() => {
//                         setSelectedClient(clientDetails);
//                         setShowModal(true);
//                     }}
//                 />
//             </div>
//             <Card.Body className="pt-3">
//                 <div className="row">
//                     {/* Left Section */}
//                     <div className="col-md-6">
//                         <div className="mb-3">
//                             <span className="text-muted d-block card-label"><strong>Business:</strong></span>
//                             <span className="text-muted card-value">{clientDetails?.business_name || '-'}</span>
//                         </div>
//                         <div className="mb-3">
//                             <span className="text-muted d-block card-label"><strong>Email:</strong></span>
//                             <span className="text-muted card-value">{clientDetails?.email || '-'}</span>
//                         </div>
//                     </div>

//                     {/* Right Section */}
//                     <div className="col-md-4">
//                         <div className="mb-3">
//                             <span className="text-muted d-block card-label"><strong>Address:</strong></span>
//                             <span className="fw-semibold text-primary card-value">{clientDetails?.Address || ''}</span>
//                         </div>
//                     </div>
//                 </div>
//             </Card.Body>
//         </Card>
//     </div>

//     {/* Avatar Card */}
//     <div className="col-md-2">
//     <Card className="text-center shadow-lg border-0 rounded-3 p-1">
//     <Card.Body className="d-flex flex-column justify-content-between">
//                 <div>
//                     <div className="d-flex justify-content-center mb-2">
//                         {clientDetails?.avatar ? (
//                             <img
//                                 src={`${process.env.REACT_APP_BACKEND_URL}/storage/${clientDetails.avatar}`}
//                                 alt="Client Avatar"
//                                 className="rounded-circle img-circle"
//                             />
//                         ) : (
//                             <div className="rounded-circle d-flex align-items-center justify-content-center bg-primary-subtle text-white fw-bold img-circle">
//                                 {clientDetails?.name ? clientDetails.name.charAt(0).toUpperCase() : "?"}
//                             </div>
//                         )}
//                     </div>
//                     <h5 className="fw-bold text-dark  font-size-13">{clientDetails?.name || "N/A"}</h5>
//                     <p className="text-muted  font-size-12">{clientDetails?.business_name || "N/A"}</p>
//                 </div>
//             </Card.Body>
//                 <div className="contact-links d-flex justify-content-around font-size-15 ">
//                     <a href="#" className="text-dark"><i className="bx bx-message"></i></a>
//                     <a href="#" className="text-dark"><i className="bx bx-phone"></i></a>
//                     <a
//                         href="#"
//                         className="text-dark"
//                         onClick={(e) => {
//                             e.preventDefault();
//                             handleTabClick("clientDetails");
//                         }}
//                     >
//                         <i className="bx bx-user-circle"></i>
//                     </a>
//                 </div>
//         </Card>
//         {showModal && (
//                             <ClientModal
//                             showModal={showModal}
//                             handleClose={() => setShowModal(false)}
//                             clientId={id}
//                             clientData={selectedClient}

//                             editClient={editContact}
//                             countries={countries}
//                             type='client'
//                             fetchCountries={fetchCountries}

//                             contacts={contacts}


//                         />
//                             )}
//     </div>
// </div>

//                         </>
//                         <div className="row">
//                     <div className="col-xl-12 col-lg-8">
//                                 <div className="card">
//                                     {/* Nav tabs */}
//                                     <ul className="nav nav-tabs nav-tabs-custom justify-content-start pt-2  font-size-13" role="tablist">
//                                         <li className="nav-item">
//                                             <WithtProjectPermission>
//                                             <a
//                                                 className={`nav-link ${activeTab === 'projectList' ? 'active' : ''}`}
//                                                 onClick={() => handleTabClick('projectList')}
//                                                 role="tab"
//                                             >
//                                                 Projects
//                                             </a>
//                                             </WithtProjectPermission>
//                                         </li>
//                                         {!isSales && (
//                                             <WithContactPermission>
//                                         <li className="nav-item">
//                                             <a
//                                                 className={`nav-link ${activeTab === 'contactList' ? 'active' : ''}`}
//                                                 onClick={() => handleTabClick('contactList')}
//                                                 role="tab"
//                                             >
//                                                 Contacts
//                                             </a>
//                                         </li>
//                                         </WithContactPermission>
//                                         )}
//                                         <li className="nav-item">
//                                             <WithDocPermission>
//                                             <a
//                                                 className={`nav-link ${activeTab === 'document' ? 'active' : ''}`}
//                                                 onClick={() => {
//                                                     handleTabClick('document');
//                                                 }}                                               
//                                                  role="tab"
//                                             >
//                                                 Document
//                                             </a>
//                                             </WithDocPermission>
//                                         </li>
//                                         <li className="nav-item">
//                                             <a
//                                                 className={`nav-link ${activeTab === 'clientDetails' ? 'active' : ''}`}
//                                                 onClick={() => handleTabClick('clientDetails')}
//                                                 role="tab"
//                                             >
//                                                 Client Details
//                                             </a>
//                                         </li>

//                                     </ul>
//                                     <div className="tab-content p-4">
//                                         {/* Contact List Tab */}
//                                         {activeTab === "contactList" && clientDetails && (
//                                             <div className="tab-pane active" id="contact-list" role="tabpanel">
//                                                 <div className="p-3">
//                                                 <SelectedContact 
//                                             clientId={clientDetails?.id} 
//                                             entityType="client" 
//                                             fetchClientData={fetchClientDetails} clientData={clientDetails} setClientDetails={setClientDetails}
//                                         />    
//                                                 </div>
//                                             </div>
//                                         )}
//                                          {activeTab === "projectList" && clientDetails && (
//                                             <div className="tab-pane active" id="project-list" role="tabpanel">
//                                                 <div className="p-3">
//                                                 <ProjectList clientId={id} />

//                                                 </div>
//                                             </div>
//                                         )}
//                                          {activeTab === "document" && clientDetails && (
//                                             <div className="tab-pane active" id="document-list" role="tabpanel">
//                                                 <div className="p-3">
//                                                 <DocumentDetails instanceId={id}/>

//                                                 </div>
//                                             </div>
//                                         )}
//                                         {activeTab === "clientDetails" && clientDetails && (
//                                             <div className="tab-pane active" id="instacne-list" role="tabpanel">
//                                                 <div className="p-3">
//                                                 <ClientView data={clientDetails} type="client" clientId={id} setClientDetails={setClientDetails} onAvatarUpdate={handleAvatarUpdate}/>
//                                                 </div>
//                                             </div>
//                                         )}
//                                         </div>
//                                     </div>
//                                     </div>

//                     </div>

//                     </div>
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default ClientDetails;


// import moment from "moment";
// import { useParams, useNavigate, useLocation } from 'react-router-dom';
// import { useState, useEffect, useRef } from 'react';
// import axios from 'axios';
// import { Offcanvas, Button } from 'react-bootstrap';
// import {
//     FaUser,
//     FaBuilding,
//     FaTag,
//     FaStickyNote,
//     FaRegClock,
//     FaUserEdit,
//     FaAddressCard,
//     FaArrowRight
// } from 'react-icons/fa';
// import { BiPencil } from "react-icons/bi";
// import { BsX } from "react-icons/bs";
// import ClientView from './ClientView';
// import DocumentDetails from '../DocumentDetails';
// import ProjectList from '../project/ProjectList';
// import SelectedContact from '../contact/SelectedContact';
// import withPermission from '../../utils/withPermission';
// import ClientModal from './ClientModal';

// const ClientDetails = ({ show, onHide, clientId, type }) => {
//     const { id } = useParams();
//     const navigate = useNavigate();
//     const location = useLocation();
//     const queryParams = new URLSearchParams(location.search);
//     const initialTab = queryParams.get("activeTab") || "projectList";

//     const [clientDetails, setClientDetails] = useState(null);
//     const [activeTab, setActiveTab] = useState(initialTab);
//     const [activities, setActivities] = useState([]);
//     const [isSales, setIsSales] = useState(false);
//     const [showModal, setShowModal] = useState(false);
//     const [selectedClient, setSelectedClient] = useState(null);
//     const [timelineUpdates, setTimelineUpdates] = useState([]);
//     const [contacts, setContacts] = useState([]);
//     const [countries, setCountries] = useState([]);
//     const [closeOffcanvas, setCloseOffcanvas] = useState(false);
//     const [showModalAfterClose, setShowModalAfterClose] = useState(false);
//     const [modalClientData, setModalClientData] = useState(null);
//     const [isTemporarilyHidden, setIsTemporarilyHidden] = useState(false);

//     const WithProjectPermission = withPermission(({ children }) => children, ['project-list']);
//     const WithContactPermission = withPermission(({ children }) => children, ['contact-list']);
//     const WithDocPermission = withPermission(({ children }) => children, ['document-list']);
//     const WithActivityPermission = withPermission(({ children }) => children, ['activity-list']);

//     const didFetchRef = useRef(false);
//     const [localShow, setLocalShow] = useState(show);

//     // Sync with parent show prop
//     useEffect(() => {
//         setLocalShow(show);
//     }, [show]);
//     // Fetch timeline updates
//     const fetchTimelineUpdates = async () => {
//         try {
//             const backendUrl = process.env.REACT_APP_BACKEND_URL;
//             const userInfo = JSON.parse(localStorage.getItem("user-info"));
//             const origin = localStorage.getItem('user-origin');
//             const token = userInfo?.token;

//             let params = {};
//             params.client_id = clientId || id;

//             if (!params.client_id) {
//                 console.warn("Missing client_id, skipping API call.");
//                 return;
//             }

//             const response = await axios.get(`${backendUrl}/api/history/all`, {
//                 headers: {
//                     Authorization: `Bearer ${token}`,
//                     'Tenant-Origin': origin,
//                 },
//                 params,
//             });

//             setTimelineUpdates(response.data.data);
//         } catch (error) {
//             console.error("Error fetching timeline updates:", error);
//         }
//     };

//     // Fetch client details
//     const fetchClientDetails = async () => {
//         try {
//             const backendUrl = process.env.REACT_APP_BACKEND_URL;
//             const userInfo = JSON.parse(localStorage.getItem('user-info'));
//             const origin = localStorage.getItem('user-origin');
//             const token = userInfo?.token;

//             const currentId = clientId || id;
//             const response = await axios.get(`${backendUrl}/api/contacts/${currentId}?type=${type}`, {
//                 headers: {
//                     'Authorization': `Bearer ${token}`,
//                     'Tenant-Origin': origin,
//                 },
//                 skipLoader: true,
//             });

//             const data = response.data.Data;
//             setClientDetails(data);
//             setIsSales(!!data.issales);
//         } catch (error) {
//             console.error('Error fetching client details:', error);
//         }
//     };

//     // Fetch activities
//     const fetchActivities = async () => {
//         try {
//             const backendUrl = process.env.REACT_APP_BACKEND_URL;
//             const userInfo = JSON.parse(localStorage.getItem('user-info'));
//             const origin = localStorage.getItem('user-origin');
//             const token = userInfo?.token;

//             const response = await axios.get(`${backendUrl}/api/activities`, {
//                 headers: {
//                     'Authorization': `Bearer ${token}`,
//                     'Tenant-Origin': origin,
//                 },
//                 params: {
//                     client_id: clientId || id,
//                 },
//             });

//             setActivities(response.data.data || []);
//         } catch (error) {
//             console.error('Error fetching activities:', error);
//         }
//     };

//     // Fetch contacts
//     const fetchContacts = async () => {
//         try {
//             const backendUrl = process.env.REACT_APP_BACKEND_URL;
//             const userInfo = JSON.parse(localStorage.getItem('user-info'));
//             const origin = localStorage.getItem('user-origin');
//             const token = userInfo?.token;

//             const response = await axios.get(`${backendUrl}/api/contact`, {
//                 headers: {
//                     Authorization: `Bearer ${token}`,
//                     'Tenant-Origin': origin,
//                 },
//                 skipLoader: true,
//             });

//             const filteredContacts = response.data.Data.filter(
//                 contact => contact.type !== "instance" && contact.type !== "tenant"
//             );

//             setContacts(filteredContacts);
//         } catch (error) {
//             console.error('Error fetching contacts:', error);
//         }
//     };

//     // Fetch countries
//     const fetchCountries = async () => {
//         try {
//             const backendUrl = process.env.REACT_APP_BACKEND_URL;
//             const userInfo = JSON.parse(localStorage.getItem('user-info'));
//             const origin = localStorage.getItem('user-origin');
//             const token = userInfo?.token;

//             const response = await axios.get(`${backendUrl}/api/countries`, {
//                 headers: {
//                     Authorization: `Bearer ${token}`,
//                     'Tenant-Origin': origin,
//                 },
//                 skipLoader: true,
//             });
//             setCountries(response.data.Data);
//         } catch (error) {
//             console.error('Error fetching countries:', error);
//         }
//     };

//     // Edit client function
//     const editClient = async (contactId, updatedData) => {
//         try {
//             const formData = new FormData();

//             Object.keys(updatedData).forEach((key) => {
//                 if (key === "avatar" && typeof updatedData[key] === "string") {
//                     return;
//                 }
//                 formData.append(key, updatedData[key]);
//             });

//             if (updatedData.avatar instanceof File) {
//                 formData.append('avatar', updatedData.avatar);
//             }

//             const backendUrl = process.env.REACT_APP_BACKEND_URL;
//             const userInfo = JSON.parse(localStorage.getItem('user-info'));
//             const origin = localStorage.getItem('user-origin');
//             const token = userInfo?.token;

//             const response = await axios.post(
//                 `${backendUrl}/api/contacts/${contactId}?_method=PUT&type=client`,
//                 formData,
//                 {
//                     headers: {
//                         Authorization: `Bearer ${token}`,
//                         'Content-Type': 'multipart/form-data',
//                         'Tenant-Origin': origin,
//                     },
//                 }
//             );

//             const updatedClient = response.data.Data;

//             if (updatedClient) {
//                 setClientDetails((prevClient) => ({
//                     ...prevClient,
//                     ...updatedClient,
//                 }));
//             }

//             setShowModal(false);
//         } catch (error) {
//             if (error.response?.data?.errors) {
//                 return error.response.data.errors;
//             } else {
//                 console.error(`Error updating client:`, error);
//             }
//         }
//     };

//     // Handle avatar update
//     const handleAvatarUpdate = (newAvatarUrl) => {
//         setClientDetails((prevDetails) => ({
//             ...prevDetails,
//             avatar: newAvatarUrl,
//         }));
//     };

//     // useEffect(() => {
//     //     if (show) {
//     //         fetchClientDetails();
//     //         fetchCountries();
//     //     }
//     // }, [show, clientId]);
//     useEffect(() => {
//         if (localShow && clientId) {
//             setClientDetails(null); // Clear previous data
//             fetchClientDetails();
//             fetchCountries();
//         }
//     }, [localShow, clientId]);


//     useEffect(() => {
//         if (show && activeTab === 'timeline') {
//             // fetchTimelineUpdates();
//         }
//     }, [show, activeTab]);

//     const handleTabClick = (tab) => {
//         setActiveTab(tab);
//     };

//     const handleOffcanvasClose = () => {
//         setClientDetails(null);
//         setActiveTab('projectList');
//         didFetchRef.current = false;
//         onHide();
//     };

//     // Group timeline by date
//     const groupByDate = (updates) => {
//         return updates.reduce((grouped, update) => {
//             const date = moment(update.created_at).format("MMM DD, YYYY");
//             if (!grouped[date]) {
//                 grouped[date] = [];
//             }
//             grouped[date].push(update);
//             return grouped;
//         }, {});
//     };

//     const groupedUpdates = groupByDate(timelineUpdates);

//     // Callback functions for ProjectList
//     const temporarilyHideOffcanvas = () => {
//         console.log("👉 temporarilyHideOffcanvas called");
//         setIsTemporarilyHidden(true);
//     };

//     const reopenOffcanvas = () => {
//         console.log("👉 reopenOffcanvas called");
//         setIsTemporarilyHidden(false);
//     };

//     // Determine if offcanvas should be shown
//     const shouldShowOffcanvas = show && !closeOffcanvas && !isTemporarilyHidden;

//     return (
//         // In ClientDetails component
//         <Offcanvas
//             show={localShow}
//             onHide={handleOffcanvasClose}
//             placement="end"
//             style={{ width: '1050px', zIndex: 1045 }} // Add z-index here
//             className="Client-offcanvas"
//         >
//             {/* Offcanvas Header */}
//             <Offcanvas.Header className="border-bottom bg-white py-3">
//                 <div className="d-flex justify-content-between align-items-center w-100">
//                     <div className="d-flex align-items-center">
//                         <div className="bg-primary rounded-circle p-2 me-3">
//                             <FaUser className="text-white" size={18} />
//                         </div>
//                         <div>
//                             <h5 className="mb-0 fw-bold text-dark">{clientDetails?.name}</h5>
//                             <small className="text-muted">ID: {clientDetails?.client_id || id}</small>
//                         </div>
//                     </div>
//                     <div className="d-flex align-items-center gap-2">
//                         <Button
//                             variant="outline-primary"
//                             size="sm"
//                             onClick={() => {
//                                 setSelectedClient(clientDetails);
//                                 setShowModal(true);
//                             }}
//                         >
//                             <BiPencil className="me-1" />
//                             Edit 
//                         </Button>

//                         <Button
//                             variant="light"
//                             size="sm"
//                             onClick={handleOffcanvasClose}
//                             className="border-0"
//                         >
//                             <BsX size={20} />
//                         </Button>
//                     </div>
//                 </div>
//             </Offcanvas.Header>

//             {/* Offcanvas Body */}
//             <Offcanvas.Body className="p-0">
//                 {/* Client Summary Card */}
//                 <div className="p-4 border-bottom bg-light">
//                     <div className="row g-4">
//                         <div className="col-md-6">
//                             <div className="d-flex align-items-center">
//                                 <div className="bg-white rounded-circle p-2 shadow-sm me-3">
//                                     <FaBuilding className="text-primary" size={16} />
//                                 </div>
//                                 <div>
//                                     <label className="text-muted small mb-1 d-block">Business Name</label>
//                                     <h6 className="mb-0 fw-semibold text-dark">
//                                         {clientDetails?.business_name || 'Not assigned'}
//                                     </h6>
//                                 </div>
//                             </div>
//                         </div>
//                         <div className="col-md-6">
//                             <div className="d-flex align-items-center">
//                                 <div className="bg-white rounded-circle p-2 shadow-sm me-3">
//                                     <FaTag className="text-primary" size={16} />
//                                 </div>
//                                 <div>
//                                     <label className="text-muted small mb-1 d-block">Email</label>
//                                     <h6 className="mb-0 fw-semibold text-dark">
//                                         {clientDetails?.email || 'Not specified'}
//                                     </h6>
//                                 </div>
//                             </div>
//                         </div>
//                         <div className="col-12">
//                             <div className="d-flex align-items-start">
//                                 <div className="bg-white rounded-circle p-2 shadow-sm me-3 mt-1">
//                                     <FaStickyNote className="text-primary" size={16} />
//                                 </div>
//                                 <div className="flex-grow-1">
//                                     <label className="text-muted small mb-1 d-block">Address</label>
//                                     <div className="bg-white p-3 rounded border">
//                                         <p className="mb-0 text-dark">
//                                             {clientDetails?.Address || 'No address available for this client.'}
//                                         </p>
//                                     </div>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                 </div>

//                 {/* Navigation Tabs */}
//                 <div className="border-bottom bg-white">
//                     <ul className="nav nav-tabs nav-tabs-custom nav-justified" role="tablist">
//                         <WithProjectPermission>
//                             <li className="nav-item">
//                                 <button
//                                     className={`nav-link ${activeTab === 'projectList' ? 'active' : ''}`}
//                                     onClick={() => handleTabClick('projectList')}
//                                     role="tab"
//                                 >
//                                     <FaBuilding className="me-2" size={14} />
//                                     Projects
//                                 </button>
//                             </li>
//                         </WithProjectPermission>

//                         {!isSales && (
//                             <WithContactPermission>
//                                 <li className="nav-item">
//                                     <button
//                                         className={`nav-link ${activeTab === 'contactList' ? 'active' : ''}`}
//                                         onClick={() => handleTabClick('contactList')}
//                                         role="tab"
//                                     >
//                                         <FaUser className="me-2" size={14} />
//                                         Contacts
//                                     </button>
//                                 </li>
//                             </WithContactPermission>
//                         )}

//                         <WithDocPermission>
//                             <li className="nav-item">
//                                 <button
//                                     className={`nav-link ${activeTab === 'document' ? 'active' : ''}`}
//                                     onClick={() => handleTabClick('document')}
//                                     role="tab"
//                                 >
//                                     <FaStickyNote className="me-2" size={14} />
//                                     Documents
//                                 </button>
//                             </li>
//                         </WithDocPermission>

//                         <li className="nav-item">
//                             <button
//                                 className={`nav-link ${activeTab === 'clientDetails' ? 'active' : ''}`}
//                                 onClick={() => handleTabClick('clientDetails')}
//                                 role="tab"
//                             >
//                                 <FaUser className="me-2" size={14} />
//                                  Details
//                             </button>
//                         </li>
//                     </ul>
//                 </div>

//                 {/* Tab Content */}
//                 <div className="tab-content p-4 bg-white" style={{ minHeight: '500px', maxHeight: 'calc(100vh - 300px)', overflowY: 'auto' }}>
//                     {/* Project List Tab */}
//                     {activeTab === "projectList" && clientDetails && (
//                         <div className="tab-pane active">
//                             <ProjectList
//                                 clientId={clientId || id}
//                                 onCloseOffcanvas={temporarilyHideOffcanvas}
//                                 onReopenOffcanvas={reopenOffcanvas}
//                             />
//                         </div>
//                     )}

//                     {/* Contact List Tab */}
//                     {activeTab === "contactList" && clientDetails && (
//                         <div className="tab-pane active">
//                             <SelectedContact
//                                 clientId={clientDetails?.id}
//                                 entityType="client"
//                                 fetchClientData={fetchClientDetails}
//                                 clientData={clientDetails}
//                                 setClientDetails={setClientDetails}
//                             />
//                         </div>
//                     )}

//                     {/* Document Tab */}
//                     {activeTab === "document" && clientDetails && (
//                         <div className="tab-pane active">
//                             <DocumentDetails instanceId={clientId || id} />
//                         </div>
//                     )}

//                     {/* Client Details Tab */}
//                     {activeTab === "clientDetails" && (
//                         <div className="tab-pane active">
//                             {clientDetails ? (
//                                 <ClientView
//                                     data={clientDetails}
//                                     type="client"
//                                     clientId={clientId || id}
//                                     setClientDetails={setClientDetails}
//                                     onAvatarUpdate={handleAvatarUpdate}
//                                 />
//                             ) : (
//                                 <div className="text-center py-5">
//                                     <div className="spinner-border text-primary" role="status">
//                                         <span className="visually-hidden">Loading...</span>
//                                     </div>
//                                     <p className="mt-2 text-muted">Loading client details...</p>
//                                 </div>
//                             )}
//                         </div>
//                     )}
//                 </div>
//             </Offcanvas.Body>

//             {/* Client Modal */}
//             {showModal && (
//                 <ClientModal
//                     showModal={showModal}
//                     handleClose={() => setShowModal(false)}
//                     clientId={clientId || id}
//                     clientData={selectedClient}
//                     editClient={editClient}
//                     countries={countries}
//                     type={type}
//                     fetchCountries={fetchCountries}
//                     contacts={contacts}
//                 />
//             )}
//         </Offcanvas>
//     );
// };

// export default ClientDetails;



import moment from "moment";
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { Offcanvas, Button } from 'react-bootstrap';
import {
    FaUser,
    FaBuilding,
    FaTag,
    FaStickyNote,
    FaRegClock,
    FaUserEdit,
    FaAddressCard,
    FaArrowRight,
    FaChartLine,
    FaFileInvoice,
    FaFileAlt,
    FaListAlt
} from 'react-icons/fa';
import { BiPencil } from "react-icons/bi";
import { BsX } from "react-icons/bs";
import ClientView from './ClientView';
import DocumentDetails from '../DocumentDetails';
import ProjectList from '../project/ProjectList';
import SelectedContact from '../contact/SelectedContact';
import withPermission from '../../utils/withPermission';
import ClientModal from './ClientModal';
import ProjectDetails from '../project/ProjectDetails'; // Import ProjectDetails
import PartnerPricing from '../sales/partner/PartnerPricing'; // Import PartnerPricing

const ClientDetails = ({ show, onHide, clientId, type }) => {
    const { id } = useParams();
    const navigate = useNavigate();
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const initialTab = queryParams.get("activeTab") || "projectList";

    const [clientDetails, setClientDetails] = useState(null);
    const [activeTab, setActiveTab] = useState(initialTab);
    const [activities, setActivities] = useState([]);
    const [isSales, setIsSales] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [selectedClient, setSelectedClient] = useState(null);
    const [timelineUpdates, setTimelineUpdates] = useState([]);
    const [contacts, setContacts] = useState([]);
    const [countries, setCountries] = useState([]);
    const [closeOffcanvas, setCloseOffcanvas] = useState(false);
    const [showModalAfterClose, setShowModalAfterClose] = useState(false);
    const [modalClientData, setModalClientData] = useState(null);
    const [isTemporarilyHidden, setIsTemporarilyHidden] = useState(false);

    // Add state for ProjectDetails offcanvas
    const [showProjectDetails, setShowProjectDetails] = useState(false);
    const [selectedProjectId, setSelectedProjectId] = useState(null);
    const [selectedProjectData, setSelectedProjectData] = useState(null);

    const WithProjectPermission = withPermission(({ children }) => children, ['project-list']);
    const WithContactPermission = withPermission(({ children }) => children, ['contact-list']);
    const WithDocPermission = withPermission(({ children }) => children, ['document-list']);
    const WithActivityPermission = withPermission(({ children }) => children, ['activity-list']);

    const didFetchRef = useRef(false);
    const [localShow, setLocalShow] = useState(show);

    // Sync with parent show prop
    useEffect(() => {
        setLocalShow(show);
        if (show) {
            setActiveTab(initialTab);
        }
    }, [show, initialTab]);

    // Fetch timeline updates
    const fetchTimelineUpdates = async () => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem("user-info"));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            let params = {};
            params.client_id = clientId || id;

            if (!params.client_id) {
                console.warn("Missing client_id, skipping API call.");
                return;
            }

            const response = await axios.get(`${backendUrl}/api/history/all`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
                params,
            });

            setTimelineUpdates(response.data.data);
        } catch (error) {
            console.error("Error fetching timeline updates:", error);
        }
    };

    // Fetch client details
    const fetchClientDetails = async () => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            const currentId = clientId || id;
            const response = await axios.get(`${backendUrl}/api/contacts/${currentId}?type=${type}`, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
                skipLoader: true,
            });

            const data = response.data.Data;
            setClientDetails(data);
            setIsSales(!!data.issales);
        } catch (error) {
            console.error('Error fetching client details:', error);
        }
    };

    // Fetch activities
    const fetchActivities = async () => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            const response = await axios.get(`${backendUrl}/api/activities`, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
                params: {
                    client_id: clientId || id,
                },
            });

            setActivities(response.data.data || []);
        } catch (error) {
            console.error('Error fetching activities:', error);
        }
    };

    // Fetch contacts
    const fetchContacts = async () => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            const response = await axios.get(`${backendUrl}/api/contact`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
                skipLoader: true,
            });

            const filteredContacts = response.data.Data.filter(
                contact => contact.type !== "instance" && contact.type !== "tenant"
            );

            setContacts(filteredContacts);
        } catch (error) {
            console.error('Error fetching contacts:', error);
        }
    };

    // Fetch countries
    const fetchCountries = async () => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            const response = await axios.get(`${backendUrl}/api/countries`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
                skipLoader: true,
            });
            setCountries(response.data.Data);
        } catch (error) {
            console.error('Error fetching countries:', error);
        }
    };

    // Edit client function
    const editClient = async (contactId, updatedData) => {
        try {
            const formData = new FormData();

            Object.keys(updatedData).forEach((key) => {
                if (key === "avatar" && typeof updatedData[key] === "string") {
                    return;
                }
                formData.append(key, updatedData[key]);
            });

            if (updatedData.avatar instanceof File) {
                formData.append('avatar', updatedData.avatar);
            }

            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            const response = await axios.post(
                `${backendUrl}/api/contacts/${contactId}?_method=PUT&type=client`,
                formData,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Content-Type': 'multipart/form-data',
                        'Tenant-Origin': origin,
                    },
                }
            );

            const updatedClient = response.data.Data;

            if (updatedClient) {
                setClientDetails((prevClient) => ({
                    ...prevClient,
                    ...updatedClient,
                }));
            }

            setShowModal(false);
        } catch (error) {
            if (error.response?.data?.errors) {
                return error.response.data.errors;
            } else {
                console.error(`Error updating client:`, error);
            }
        }
    };

    // Handle avatar update
    const handleAvatarUpdate = (newAvatarUrl) => {
        setClientDetails((prevDetails) => ({
            ...prevDetails,
            avatar: newAvatarUrl,
        }));
    };

    useEffect(() => {
        if (localShow && clientId) {
            setClientDetails(null); // Clear previous data
            fetchClientDetails();
            fetchCountries();
        }
    }, [localShow, clientId]);

    useEffect(() => {
        if (show && activeTab === 'timeline') {
            // fetchTimelineUpdates();
        }
    }, [show, activeTab]);

    const handleTabClick = (tab) => {
        setActiveTab(tab);
    };

    const handleOffcanvasClose = () => {
        setClientDetails(null);
        setActiveTab('projectList');
        didFetchRef.current = false;
        onHide();
    };

    // Callback functions for ProjectList
    const temporarilyHideOffcanvas = () => {
        console.log("👉 temporarilyHideOffcanvas called");
        setIsTemporarilyHidden(true);
    };

    const reopenOffcanvas = () => {
        console.log("👉 reopenOffcanvas called");
        setIsTemporarilyHidden(false);
    };

    // Function to handle opening ProjectDetails
    const handleOpenProjectDetails = (projectId, projectData) => {
        // Close ClientDetails offcanvas
        setIsTemporarilyHidden(true);

        // Set the project data and open ProjectDetails
        setSelectedProjectId(projectId);
        setSelectedProjectData(projectData);
        setShowProjectDetails(true);
    };

    // Function to handle closing ProjectDetails
    const handleCloseProjectDetails = () => {
        setShowProjectDetails(false);
        setSelectedProjectId(null);
        setSelectedProjectData(null);

        // Reopen ClientDetails offcanvas
        setIsTemporarilyHidden(false);
    };

    // Determine if offcanvas should be shown
    const shouldShowOffcanvas = show && !closeOffcanvas && !isTemporarilyHidden;

    return (
        <>
            {/* ClientDetails Offcanvas */}
            <Offcanvas
                show={localShow && !isTemporarilyHidden}
                onHide={handleOffcanvasClose}
                placement="end"
                style={{ width: '1050px', zIndex: 1045 }}
                className="Client-offcanvas"
                enforceFocus={false}
                autoFocus={false}
                restoreFocus={false}
            >
                {/* Offcanvas Header */}
                <Offcanvas.Header className="border-bottom bg-white py-3">
                    <div className="d-flex justify-content-between align-items-center w-100">
                        <div className="d-flex align-items-center">
                            <div className="bg-primary rounded-circle p-2 me-3">
                                <FaUser className="text-white" size={18} />
                            </div>
                            <div>
                                <h5 className="mb-0 fw-bold text-dark">{clientDetails?.name}</h5>
                                <small className="text-muted">ID: {clientDetails?.client_id || id}</small>
                            </div>
                        </div>
                        <div className="d-flex align-items-center gap-2">
                            <Button
                                variant="outline-primary"
                                size="sm"
                                onClick={() => {
                                    setSelectedClient(clientDetails);
                                    setShowModal(true);
                                }}
                            >
                                <BiPencil className="me-1" />
                                Edit
                            </Button>

                            <Button
                                variant="light"
                                size="sm"
                                onClick={handleOffcanvasClose}
                                className="border-0"
                            >
                                <BsX size={20} />
                            </Button>
                        </div>
                    </div>
                </Offcanvas.Header>

                {/* Offcanvas Body */}
                <Offcanvas.Body className="p-0">
                    {/* Client Summary Card */}
                    <div className="p-4 border-bottom bg-light">
                        <div className="row g-4">
                            <div className="col-md-6">
                                <div className="d-flex align-items-center">
                                    <div className="bg-white rounded-circle p-2 shadow-sm me-3">
                                        <FaBuilding className="text-primary" size={16} />
                                    </div>
                                    <div>
                                        <label className="text-muted small mb-1 d-block">Business Name</label>
                                        <h6 className="mb-0 fw-semibold text-dark">
                                            {clientDetails?.business_name || 'Not assigned'}
                                        </h6>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="d-flex align-items-center">
                                    <div className="bg-white rounded-circle p-2 shadow-sm me-3">
                                        <FaTag className="text-primary" size={16} />
                                    </div>
                                    <div>
                                        <label className="text-muted small mb-1 d-block">Email</label>
                                        <h6 className="mb-0 fw-semibold text-dark">
                                            {clientDetails?.email || 'Not specified'}
                                        </h6>
                                    </div>
                                </div>
                            </div>
                            <div className="col-12">
                                <div className="d-flex align-items-start">
                                    <div className="bg-white rounded-circle p-2 shadow-sm me-3 mt-1">
                                        <FaStickyNote className="text-primary" size={16} />
                                    </div>
                                    <div className="flex-grow-1">
                                        <label className="text-muted small mb-1 d-block">Address</label>
                                        <div className="bg-white p-3 rounded border">
                                            <p className="mb-0 text-dark">
                                                {clientDetails?.Address || 'No address available for this client.'}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Navigation Tabs */}
                    <div className="border-bottom bg-white">
                        <ul className="nav nav-tabs nav-tabs-custom nav-justified" role="tablist">
                            {/* <li className="nav-item">
                                <button
                                    className={`nav-link ${activeTab === 'overview' ? 'active' : ''}`}
                                    onClick={() => handleTabClick('overview')}
                                    role="tab"
                                >
                                    <FaChartLine className="me-2" size={14} />
                                    Overview
                                </button>
                            </li> */}

                            <WithProjectPermission>
                                <li className="nav-item">
                                    <button
                                        className={`nav-link ${activeTab === 'projectList' ? 'active' : ''}`}
                                        onClick={() => handleTabClick('projectList')}
                                        role="tab"
                                    >
                                        <FaBuilding className="me-2" size={14} />
                                        Projects
                                    </button>
                                </li>
                            </WithProjectPermission>

                            <li className="nav-item">
                                <button
                                    className={`nav-link ${activeTab === 'customerOrder' ? 'active' : ''}`}
                                    onClick={() => handleTabClick('customerOrder')}
                                    role="tab"
                                >
                                    <FaListAlt className="me-2" size={14} />
                                    Orders
                                </button>
                            </li>

                            <li className="nav-item">
                                <button
                                    className={`nav-link ${activeTab === 'vendorPO' ? 'active' : ''}`}
                                    onClick={() => handleTabClick('vendorPO')}
                                    role="tab"
                                >
                                    <FaFileInvoice className="me-2" size={14} />
                                    Vendor POs
                                </button>
                            </li>

                            {!isSales && (
                                <WithContactPermission>
                                    <li className="nav-item">
                                        <button
                                            className={`nav-link ${activeTab === 'contactList' ? 'active' : ''}`}
                                            onClick={() => handleTabClick('contactList')}
                                            role="tab"
                                        >
                                            <FaUser className="me-2" size={14} />
                                            Contacts
                                        </button>
                                    </li>
                                </WithContactPermission>
                            )}

                            <WithDocPermission>
                                <li className="nav-item">
                                    <button
                                        className={`nav-link ${activeTab === 'document' ? 'active' : ''}`}
                                        onClick={() => handleTabClick('document')}
                                        role="tab"
                                    >
                                        <FaStickyNote className="me-2" size={14} />
                                        Documents
                                    </button>
                                </li>
                            </WithDocPermission>

                            <li className="nav-item">
                                <button
                                    className={`nav-link ${activeTab === 'clientDetails' ? 'active' : ''}`}
                                    onClick={() => handleTabClick('clientDetails')}
                                    role="tab"
                                >
                                    <FaUser className="me-2" size={14} />
                                    Details
                                </button>
                            </li>
                            <li className="nav-item">
                                <button
                                    className={`nav-link ${activeTab === 'partnerPricing' ? 'active' : ''}`}
                                    onClick={() => handleTabClick('partnerPricing')}
                                    role="tab"
                                >
                                    <FaTag className="me-2" size={14} />
                                    Partner Pricing
                                </button>
                            </li>
                        </ul>
                    </div>

                    {/* Tab Content */}
                    <div className="tab-content p-4 bg-white" style={{ minHeight: '500px', maxHeight: 'calc(100vh - 300px)', overflowY: 'auto' }}>
                        {/* Overview Tab */}
                        {/* Overview Tab */}
                        {false && activeTab === "overview" && clientDetails && (
                            <div className="tab-pane active">
                                <div className="row g-4">
                                    <div className="col-lg-8">
                                        {/* Metric Cards Row */}
                                        <div className="row g-3 mb-4">
                                            <div className="col-md-4">
                                                <div className="card shadow-sm border-0 bg-primary-subtle" 
                                                     style={{ borderRadius: '12px', cursor: 'pointer', borderLeft: '5px solid #0d6efd' }}
                                                     onClick={() => setActiveTab('projectList')}>
                                                    <div className="card-body p-3">
                                                        <div className="d-flex align-items-center justify-content-between mb-2">
                                                            <div className="bg-primary bg-opacity-10 p-2 rounded text-primary">
                                                                <FaBuilding size={14} />
                                                            </div>
                                                            <span className="text-muted small fw-semibold text-uppercase">Projects</span>
                                                        </div>
                                                        <h3 className="mb-0 fw-bold">{clientDetails.projects_count || 0}</h3>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-4">
                                                <div className="card shadow-sm border-0 bg-success-subtle" 
                                                     style={{ borderRadius: '12px', cursor: 'pointer', borderLeft: '5px solid #198754' }}
                                                     onClick={() => setActiveTab('customerOrder')}>
                                                    <div className="card-body p-3">
                                                        <div className="d-flex align-items-center justify-content-between mb-2">
                                                            <div className="bg-success bg-opacity-10 p-2 rounded text-success">
                                                                <FaListAlt size={14} />
                                                            </div>
                                                            <span className="text-muted small fw-semibold text-uppercase">Orders</span>
                                                        </div>
                                                        <h3 className="mb-0 fw-bold">{clientDetails.client_deals_count || 0}</h3>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-4">
                                                <div className="card shadow-sm border-0 bg-info-subtle" 
                                                     style={{ borderRadius: '12px', cursor: 'pointer', borderLeft: '5px solid #0dcaf0' }}
                                                     onClick={() => setActiveTab('vendorPO')}>
                                                    <div className="card-body p-3">
                                                        <div className="d-flex align-items-center justify-content-between mb-2">
                                                            <div className="bg-info bg-opacity-10 p-2 rounded text-info">
                                                                <FaFileInvoice size={14} />
                                                            </div>
                                                            <span className="text-muted small fw-semibold text-uppercase">Vendor POs</span>
                                                        </div>
                                                        <h3 className="mb-0 fw-bold">{clientDetails.purchase_orders_count || 0}</h3>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        {/* Full Details Section */}
                                        <div className="card border-0 shadow-sm rounded-3">
                                            <div className="card-header bg-white py-3 border-bottom-0">
                                                <h6 className="mb-0 fw-bold text-primary">Account Information</h6>
                                            </div>
                                            <div className="card-body pt-0">
                                                <div className="row g-4 pt-2">
                                                    <div className="col-sm-6">
                                                        <div className="mb-4">
                                                            <label className="text-muted small fw-bold text-uppercase d-block mb-1">Company Group</label>
                                                            <span className="text-dark fw-medium">{clientDetails.customer_group || 'No Group Specified'}</span>
                                                        </div>
                                                        <div className="mb-4">
                                                            <label className="text-muted small fw-bold text-uppercase d-block mb-1">Tax Registration (TRN)</label>
                                                            <span className="text-dark fw-medium">{clientDetails.tax_number || 'N/A'}</span>
                                                        </div>
                                                        <div className="mb-4">
                                                            <label className="text-muted small fw-bold text-uppercase d-block mb-1">Official Website</label>
                                                            <a href={clientDetails.website} target="_blank" rel="noreferrer" className="text-primary text-decoration-none">
                                                                {clientDetails.website || 'Add website'}
                                                            </a>
                                                        </div>
                                                    </div>
                                                    <div className="col-sm-6">
                                                        <div className="mb-4">
                                                            <label className="text-muted small fw-bold text-uppercase d-block mb-1">Client Email</label>
                                                            <span className="text-dark fw-medium">{clientDetails.email || '-'}</span>
                                                        </div>
                                                        <div className="mb-4">
                                                            <label className="text-muted small fw-bold text-uppercase d-block mb-1">Contact Phone</label>
                                                            <span className="text-dark fw-medium">{clientDetails.mobile || '-'}</span>
                                                        </div>
                                                        <div className="mb-4">
                                                            <label className="text-muted small fw-bold text-uppercase d-block mb-1">Short Code / External ID</label>
                                                            <span className="text-dark fw-bold">{clientDetails.short_code || clientDetails.external_id || '-'}</span>
                                                        </div>
                                                    </div>
                                                    <div className="col-12 mt-0">
                                                        <hr className="my-3 opacity-10" />
                                                        <div className="mb-2">
                                                            <label className="text-muted small fw-bold text-uppercase d-block mb-2">Primary Address</label>
                                                            <div className="p-3 bg-light rounded border border-dashed text-dark small">
                                                                <div className="d-flex align-items-center mb-1">
                                                                    <FaTag className="text-muted me-2" size={12} />
                                                                    <span>{clientDetails.address || 'Address not registered'}</span>
                                                                </div>
                                                                <div className="ps-4 text-muted">
                                                                    {[clientDetails.city, clientDetails.state, clientDetails.zip].filter(Boolean).join(', ')}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Right Column: Activity Timeline */}
                                    <div className="col-lg-4 border-start">
                                        <div className="px-2">
                                            <h6 className="fw-bold mb-4 d-flex align-items-center border-bottom pb-3">
                                                <FaChartLine className="text-info me-2" />
                                                Activity Timeline
                                            </h6>
                                            <div className="timeline ms-2" style={{ maxHeight: '600px', overflowY: 'auto' }}>
                                                {(
                                                    // Merge local events with activities
                                                    [
                                                        ...(clientDetails.projects || []).map(p => ({ date: p.created_at, title: 'New Project', desc: p.name, type: 'primary', icon: <FaBuilding /> })),
                                                        ...(clientDetails.client_deals || []).filter(d => d.stage === 'order').map(d => ({ date: d.issue_date || d.created_at, title: 'Order Received', desc: d.name, type: 'success', icon: <FaListAlt /> })),
                                                        ...(clientDetails.purchase_orders || []).map(po => ({ date: po.date || po.created_at, title: 'PO Issued', desc: po.ref_no, type: 'info', icon: <FaFileInvoice /> })),
                                                        ...(activities || []).map(act => ({ date: act.created_at, title: act.title || 'Note Added', desc: act.description, type: 'secondary', icon: <FaTag /> }))
                                                    ].sort((a, b) => new Date(b.date) - new Date(a.date)).slice(0, 15)
                                                ).map((item, i) => (
                                                    <div key={i} className="d-flex mb-4 position-relative">
                                                        <div className="flex-shrink-0 me-3">
                                                            <div className={`avatar-xs`} style={{width: '34px', height: '34px'}}>
                                                                <span className={`avatar-title bg-${item.type}-subtle text-${item.type} rounded-circle font-size-14`}>
                                                                    {item.icon}
                                                                </span>
                                                            </div>
                                                        </div>
                                                        <div className="flex-grow-1">
                                                            <div className="d-flex justify-content-between">
                                                                <h6 className="font-size-13 mb-1 fw-bold text-dark">{item.title}</h6>
                                                                <small className="text-muted" style={{ fontSize: '10px' }}>{moment(item.date).fromNow()}</small>
                                                            </div>
                                                            <p className="text-muted mb-0 small line-clamp-2">{item.desc}</p>
                                                        </div>
                                                    </div>
                                                ))}
                                                {(!clientDetails.projects?.length && !clientDetails.client_deals?.length && !activities?.length) && (
                                                    <div className="text-center py-5">
                                                        <p className="text-muted small">No recent activity found.</p>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}

                        {/* Customer Orders Tab */}
                        {activeTab === "customerOrder" && clientDetails && (
                            <div className="tab-pane active">
                                <div className="d-flex justify-content-between align-items-center mb-3">
                                    <h6 className="fw-bold mb-0">Customer Given Orders</h6>
                                </div>
                                <div className="table-responsive">
                                    <table className="table table-hover align-middle font-size-13 custom-table shadow-sm rounded">
                                        <thead className="bg-light-subtle border-bottom">
                                            <tr>
                                                <th className="py-3" style={{ width: '50px' }}>#</th>
                                                <th className="py-3">PO Number</th>
                                                <th className="py-3">Issue Date</th>
                                                <th className="py-3">Project</th>
                                                <th className="py-3 text-end">Order Value</th>
                                                <th className="py-3 text-end">Recurring Cost</th>
                                                <th className="py-3 text-end">One-Time Cost</th>
                                            </tr>
                                        </thead>
                                        <tbody className="border-0">
                                            {clientDetails.client_deals?.filter(d => d.stage === 'order').map((deal, index) => (
                                                <tr key={`deal-${deal.id}`} className="border-bottom-0">
                                                    <td className="text-muted">{index + 1}</td>
                                                    <td className="fw-medium text-primary">{deal.po_number || deal.external_id}</td>
                                                    <td className="text-muted">{deal.issue_date ? moment(deal.issue_date).format('DD MMM YYYY') : '-'}</td>
                                                    <td>
                                                        <div className="text-muted" style={{ fontSize: '11px' }}>{deal.name}</div>
                                                    </td>
                                                    <td className="text-end fw-bold">{parseFloat(deal.po_value || deal.value || 0).toLocaleString()}</td>
                                                    <td className="text-end text-primary">{parseFloat(deal.recurring_cost || 0).toLocaleString()}</td>
                                                    <td className="text-end">{parseFloat(deal.one_time_cost || 0).toLocaleString()}</td>
                                                </tr>
                                            ))}
                                            {(!clientDetails.client_deals?.some(d => d.stage === 'order')) && (
                                                <tr>
                                                    <td colSpan="7" className="text-center py-5">
                                                        <div className="text-muted mb-2">No customer orders found.</div>
                                                        <FaFileAlt size={24} className="text-light-subtle" />
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        )}

                        {/* Vendor PO List Tab */}
                        {activeTab === "vendorPO" && clientDetails && (
                            <div className="tab-pane active">
                                <div className="d-flex justify-content-between align-items-center mb-3">
                                    <h6 className="fw-bold mb-0">Vendor Purchase Orders</h6>
                                </div>
                                <div className="table-responsive">
                                    <table className="table table-hover align-middle font-size-13 custom-table shadow-sm rounded">
                                        <thead className="bg-light-subtle border-bottom">
                                            <tr>
                                                <th className="py-3" style={{ width: '50px' }}>Sl No</th>
                                                <th className="py-3">PO Reference</th>
                                                <th className="py-3">Issue Date</th>
                                                <th className="py-3">Vendor / Project</th>
                                                <th className="py-3 text-end">Total Amount</th>
                                            </tr>
                                        </thead>
                                        <tbody className="border-0">
                                            {clientDetails.purchase_orders?.map((po, index) => (
                                                <tr key={`po-${po.id}`} className="border-bottom-0">
                                                    <td className="text-muted">{index + 1}</td>
                                                    <td className="fw-medium text-info">{po.ref_no}</td>
                                                    <td className="text-muted">{moment(po.date).format('DD MMM YYYY')}</td>
                                                    <td>
                                                        <div className="text-dark fw-medium small">{po.vendor?.name}</div>
                                                        <div className="text-muted" style={{ fontSize: '11px' }}>{po.project?.name || 'Direct Procurement'}</div>
                                                    </td>
                                                    <td className="text-end fw-bold">{parseFloat(po.total_amount || 0).toLocaleString()}</td>
                                                </tr>
                                            ))}
                                            {(!clientDetails.purchase_orders?.length) && (
                                                <tr>
                                                    <td colSpan="5" className="text-center py-5">
                                                        <div className="text-muted mb-2">No vendor purchase orders found.</div>
                                                        <FaFileAlt size={24} className="text-light-subtle" />
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        )}

                        {/* Project List Tab */}
                        {activeTab === "projectList" && clientDetails && (
                            <div className="tab-pane active">
                                <ProjectList
                                    clientId={clientId || id}
                                    onCloseOffcanvas={temporarilyHideOffcanvas}
                                    onReopenOffcanvas={reopenOffcanvas}
                                    onOpenProjectDetails={handleOpenProjectDetails} // Pass the callback
                                />
                            </div>
                        )}

                        {/* Contact List Tab */}
                        {activeTab === "contactList" && clientDetails && (
                            <div className="tab-pane active">
                                <SelectedContact
                                    clientId={clientDetails?.id}
                                    entityType="client"
                                    fetchClientData={fetchClientDetails}
                                    clientData={clientDetails}
                                    setClientDetails={setClientDetails}
                                    onCloseOffcanvas={temporarilyHideOffcanvas}
                                    onReopenOffcanvas={reopenOffcanvas}
                                />
                            </div>
                        )}

                        {/* Document Tab */}
                        {activeTab === "document" && clientDetails && (
                            <div className="tab-pane active">
                                <DocumentDetails instanceId={clientId || id} />
                            </div>
                        )}

                        {/* Client Details Tab */}
                        {activeTab === "clientDetails" && (
                            <div className="tab-pane active">
                                {clientDetails ? (
                                    <ClientView
                                        data={clientDetails}
                                        type="client"
                                        clientId={clientId || id}
                                        setClientDetails={setClientDetails}
                                        onAvatarUpdate={handleAvatarUpdate}
                                    />
                                ) : (
                                    <div className="text-center py-5">
                                        <div className="spinner-border text-primary" role="status">
                                            <span className="visually-hidden">Loading...</span>
                                        </div>
                                        <p className="mt-2 text-muted">Loading client details...</p>
                                    </div>
                                )}
                            </div>
                        )}

                        {/* Partner Pricing Tab */}
                        {activeTab === "partnerPricing" && (
                            <div className="tab-pane active">
                                <PartnerPricing partnerId={clientId || id} />
                            </div>
                        )}
                    </div>
                </Offcanvas.Body>

                {/* Client Modal */}
                {showModal && (
                    <ClientModal
                        showModal={showModal}
                        handleClose={() => setShowModal(false)}
                        clientId={clientId || id}
                        clientData={selectedClient}
                        editClient={editClient}
                        countries={countries}
                        type={type}
                        fetchCountries={fetchCountries}
                        contacts={contacts}
                    />
                )}
            </Offcanvas>

            {/* ProjectDetails Offcanvas */}
            {showProjectDetails && (
                <ProjectDetails
                    show={showProjectDetails}
                    onHide={handleCloseProjectDetails}
                    projectId={selectedProjectId}
                />
            )}
        </>
    );
};

export default ClientDetails;
